import React, {Component} from 'react';
import axios from "axios";
import {isModel} from '../../Templates/functions'

class DropZone extends Component {

    state = {
        selectedFiles: [],
        errorMessage: ""
    }

    dragOver = (e) => {
        e.preventDefault();
    }

    dragEnter = (e) => {
        e.preventDefault();
    }
    
    dragLeave = (e) => {
        e.preventDefault();
    }
    
    fileDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files.length) {
            this.handleFiles(files);
        }
    }

    fileInputClicked = () => {
        let input = document.getElementById("dropzone-file-input")
        input.click()
    }

    filesSelected = (e) => {
        if (e.currentTarget.files.length > 0) {
            this.handleFiles(e.currentTarget.files)
        }
    }
    //We return the string 0 Bytes if the size is zero. 1 KB is equivalent to 1024 bytes. 
    // We calculate the natural log of the size by dividing by the natural log of bytes value. Math.floor returns an integer. 
    // The return value of the function is the size divided by the value of k to the power of i with the sizes value appended.
    fileSize = (size) => {
        if (size === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(size) / Math.log(k));
        return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    fileType = (fileName) => {
        return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
    }

    handleFiles = (files) => {
        let selectedFiles = []
        for (let i = 0; i < files.length; i++) {
            let validFile = this.validateFile(files[i])
            if (validFile) {

                let form_data = new FormData();
                form_data.append("file_name", files[i]);
				
				let initFile = {
                            name: files[i].name.substring(0, files[i].name.lastIndexOf('.')),
                            _id: "",
							progress: "Upload",
							message: ""
                        }
				this.props.appendFileToList(initFile)
				
                axios.post(`/api/mp/upload`, form_data,
                {
                    headers: {
                      "Content-Type": "multipart/form-data"
                    },
                    maxContentLength: Infinity,
                    maxBodyLength: Infinity
                    // maxContentLength: 21474836480,
                    // maxBodyLength: 21474836480, // I have tried setting these values with both numbers and the keyword Infinity but nothing works
                  }
                ).then(res => {
                    if (res.data.name) {
                        let file = {
                            name: res.data.name,
                            _id: res.data._id,
							progress: "Upload",
							message: ""
                        }
                        this.props.appendFileToList(file)
                    }
                }).catch(function (error) {
                    alert(error.response.data)
                });
            } else if (validFile === 0) {
                files[i]["invalid"] = "Invalid File Type"
                selectedFiles.push(files[i])
            } else {
                files[i]["invalid"] = "Invalid File Type"
                selectedFiles.push(files[i])
            }
        }
        this.setState(prevState => ({
            selectedFiles: selectedFiles
        }))


    }
    removeFile = (name) => {
        this.setState(prevState => ({
            selectedFiles: prevState.selectedFiles.filter(file => file.name !== name)
        }));
    }

    uploadFile = (name) => {
        this.setState(prevState => ({
            selectedFiles: prevState.selectedFiles.filter(file => file.name !== name)
        }));
    }
    
    validateFile = (file) => {
       // Remove space restriction - handle spaces properly
       // if (file.name.indexOf(' ') >= 0) {
       //     return 0
       // } else {
           var parts = file.name.split('.');
           var ext = parts[parts.length - 1];
           return (isModel(ext))
        // }
    }

    render = () => {
        return (
            <div className="file-upload-content flex-column-centered max-width">
                <div className="drop-container flex-centered max-width"
                    onClick={this.fileInputClicked}
                    onDragOver={this.dragOver}
                    onDragEnter={this.dragEnter}
                    onDragLeave={this.dragLeave}
                    onDrop={this.fileDrop}
                >
                    <div className="drop-message flex-centered">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="37" viewBox="0 0 32 37" fill="none">
                            <path d="M0 0V4.625H31.7143V0H0ZM0 23.125H9.06122V37H22.6531V23.125H31.7143L15.8571 6.9375L0 23.125Z" fill="white" />
                        </svg>
                        <p>
                            Drop files here or click to upload
                        </p>
                    </div>
                    <input
                        className="file-input"
                        id={"dropzone-file-input"}
                        type="file"
                        multiple
                        onChange={this.filesSelected}
                    />
                </div>
                <div className="file-display-container max-width">
                    {this.state.selectedFiles.map((data, i) =>
                        <div className="file-status-bar max-width" key={i}>
                            <div>
                                <div className="file-type-logo"></div>
                                <div className="file-type">{this.fileType(data.name)}</div>
                                <span className={`file-name ${data.invalid ? 'file-error' : ''}`}>{data.name}</span>
                                <span className="file-size">({this.fileSize(data.size)})</span> {data.invalid && <span className='file-error-message'>({data.invalid})</span>}
                            </div>
                            {data.invalid ? <div className="file-remove clickable" onClick={() => this.removeFile(data.name)}>X</div> : null}
                            {/* <div className="file-upload clickable" onClick={() => this.uploadFile(data.name)}>Upload</div> */}
                        </div>
                        )
                    }
                </div>
            </div>
        )
    }
}
export default DropZone;